<template>
  <div v-if="title!==''">
    <div class="header">{{title}}</div>
    <div class="header-bar"></div>
  </div>
</template>

<script>
export default {
  name: "HeaderNav",
  props:{
    title: {
      type: String,
      default: ''
    }
  },
  methods: { }
}
</script>

<style lang="scss">
.header{
  width: 100%;
  height: 44px;
  font-size: 18px;
  color: #222;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #EEEEEE;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1999;
}
.header-bar{
  width: 100%;
  height: 44px;
}
@media screen and (max-width:750px){

}
@media screen and (min-width:750px){
  .header{
    width: 375px;
    left: 50%;
    transform: translateX(-50%);
    top: 50px;
    border-radius: 8px 8px 0 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderNav.vue